import React from 'react'
import {
  Button,
  mergeClasses,
  Tooltip,
} from "@fluentui/react-components";
import {
  Send20Filled,
  Add20Filled,
  Stop20Filled,
} from "@fluentui/react-icons";
import { useTranslation } from 'react-i18next';
import { Attachment } from '../../../../../contexts/SettingsContext';

const ComposerActions: React.FC<{
  styles: any;
  isTyping: boolean;
  attachments: (string | Attachment)[];
  onAttach: () => void;
  onSend: () => void;
  onStop: () => void;
  canSend: boolean;
}> = ({
  styles,
  isTyping,
  attachments,
  onAttach,
  onSend,
  onStop,
  canSend,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.buttonsRow}>
      <div className={styles.leftButtons}>
        <Tooltip content={t("chat.attachRows")} relationship="label">
          <Button
            appearance="subtle"
            icon={<Add20Filled />}
            onClick={onAttach}
            className={mergeClasses(styles.iconButton, styles.attachButton)}
          />
        </Tooltip>

        {attachments.length > 0 && (
          <div className={styles.attachmentCount}>
            +{attachments.length}
          </div>
        )}
      </div>

      <div className={styles.rightButtons}>
        {isTyping ? (
          <Tooltip content={t("chat.stopGeneration")} relationship="label">
            <Button
              icon={<Stop20Filled />}
              onClick={onStop}
              className={mergeClasses(styles.iconButton, styles.stopButton)}
            />
          </Tooltip>
        ) : (
          <Tooltip content={t("chat.sendMessage")} relationship="label">
            <Button
              icon={<Send20Filled />}
              onClick={onSend}
              disabled={!canSend}
              className={mergeClasses(styles.iconButton, styles.sendButton)}
            />
          </Tooltip>
        )}
      </div>
    </div>
  );
};


export default ComposerActions;
